export class VehicleCompositionModel {
    public vehicleCompositionId: string;
    public organisationId: string;
    public vehicleTypeCode: string;
    public compositionCode: string;
    public compositionName: string;
}